import React from "react";
import ToggleLinkSession from "@common/components/shared/LinkSession/ToggleLinkSession";
import LinkedSession from "@common/components/shared/LinkSession/LinkedSession";
import useLinkedSession from "../../hooks/useLinkedSession";

const LinkSessionComponent = () => {
  const { name } = useLinkedSession();

  return (
    <>
      <ToggleLinkSession name={name} />
      <LinkedSession />
    </>
  );
};

export default LinkSessionComponent;
